import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { metadataApi } from '../../services/api';

/**
 * ClickHouse metadata — task tanımlarında drop-down'larda kullanılır.
 * Tablolar (kanonik liste backend'in TABLE_LABELS'inden gelir):
 *   as_uretim, as_yenileme, as_prim, as_saglik, as_grup_saglik,
 *   as_teklif, as_ziyaret, as_rota_hedefler, as_hedef_musteri, as_kanal_bilgisi
 */
// Backend response her iki sekilde de dondukten sonra normalize ediyoruz:
// - Yeni format: {key, label, name, type, nullable, row_count}
// - Eski format: {name, label, type, nullable, row_count}
// UI dropdown'lari t.key / c.key bekledigi icin, eski format geldiginde
// name'i key'e kopyalayip label fallback'i uyguluyoruz. Deploy sirasinda
// frontend eski backend'le calisabilir veya tam tersi — bu normalize
// iki yondeki versiyon uyumsuzlugunu tolere ediyor.
function _normalizeTable(t) {
  if (!t) return t;
  return {
    ...t,
    key: t.key || t.name || '',
    label: t.label || t.name || '',
  };
}

function _normalizeColumn(c) {
  if (!c) return c;
  return {
    ...c,
    key: c.key || c.name || '',
    label: c.label || c.name || c.key || '',
  };
}

export const fetchChTables = createAsyncThunk(
  'metadata/chTables',
  async (_, { rejectWithValue }) => {
    try {
      const res = await metadataApi.chTables();
      return Array.isArray(res.data) ? res.data.map(_normalizeTable) : [];
    } catch (err) {
      return rejectWithValue(err.message);
    }
  },
);

export const fetchChColumns = createAsyncThunk(
  'metadata/chColumns',
  async (table, { rejectWithValue }) => {
    try {
      const res = await metadataApi.chColumns(table);
      const normalized = Array.isArray(res.data)
        ? res.data.map(_normalizeColumn)
        : [];
      return { table, columns: normalized };
    } catch (err) {
      return rejectWithValue(err.message);
    }
  },
);

const initialState = {
  tables: [],
  columns: {}, // { [tableName]: [ { name, type } ] }
  status: 'idle',
  error: null,
};

const metadataSlice = createSlice({
  name: 'metadata',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchChTables.pending, (s) => { s.status = 'loading'; })
      .addCase(fetchChTables.fulfilled, (s, a) => {
        s.status = 'succeeded';
        s.tables = a.payload;
      })
      .addCase(fetchChTables.rejected, (s, a) => { s.status = 'failed'; s.error = a.payload; })

      .addCase(fetchChColumns.fulfilled, (s, a) => {
        s.columns[a.payload.table] = a.payload.columns;
      });
  },
});

export default metadataSlice.reducer;
